<script>
import { validateEmail } from '@/api/api'
import SignUp2 from '@/dialogs/SignUp2.vue'

export default {
  name: 'EmailValidation',
  props: ['hash', 'loginCallback'],
  data() {
    return {
      validating: true,
      validated: false,
      validateError: false
    }
  },
  mounted() {
    validateEmail(this.hash)
      .then(() => {
        this.validating = false
        this.validated = true
      })
      .catch(() => {
        this.validating = false
        this.validateError = true
      })

    /*  this.$nextTick(async () => {
      try {
        await validateEmail(this.hash)
        this.validating = false
        this.$emit('close')
        this.loginCallback()
      } catch (error) {
        // TODO: handle this properly
        console.log(error)
      }
    }) */
  },
  methods: {
    login() {
      this.$emit('close')
      this.$modal.show('login')
    },
    signUp() {
      this.$emit('close')
      this.$modal.show(SignUp2, null, {
        height: 'auto',
        width: 420
      })
    }
  }
}
</script>

<template>
  <section>
    <section class="dialog-header">
      <h1>Uw nieuwe Rijnja.nl account</h1>
    </section>
    <section class="dialog-content">
      <p v-if="validating">Uw e-mailadres wordt gecontroleerd...</p>
      <template v-else-if="validated">
        <p>
          Welkom bij Rijnja.nl, uw account is gevalideerd. Klik op de knop
          DOORGAAN om direct gebruikt te kunnen maken van uw account.
        </p>
        <div class="button-holder">
          <button @click="login" class="pill-button">Doorgaan</button>
        </div>
      </template>
      <template v-else-if="validateError">
        <p>
          De validatielink is verlopen. Klik op de knop NIEUWE REGISTRATIE om
          een nieuw Rijnja.nl account aan te maken.
        </p>
        <div class="button-holder">
          <button @click="signUp" class="pill-button">
            Nieuwe registratie
          </button>
        </div>
      </template>
    </section>
  </section>
</template>

<style scoped lang="scss"></style>
